import React from "react";
import { NavLink } from "react-router-dom";

import {FaCheck, FaLock, FaUnlock } from "react-icons/fa";

import thumb_opinion from "../../../assets/img/sua-opiniao.png";

export default function ModuleNPSComponent({
   courseFinishState,
   courseFinishedDB,
   is_answered,
   npsReference,
}) {

  let npsURL = (courseFinishState || courseFinishedDB) && !is_answered ? npsReference : null;

  return (
    <div className="course-item-sider-bar">
      <NavLink
        className={`nps ${!(courseFinishState || courseFinishedDB) && !is_answered && "disabled"}`}
        to={ npsURL ? npsURL : "#" }
      >
        <div className="course-item-icon">
          {(courseFinishState || courseFinishedDB )
          ?
            !is_answered
            ?
              (
                <FaUnlock color={"#009ee2"}/>
              )
            : (
                <FaCheck color={"#07a803"}/>
              )
          : (
              <FaLock color={"#ff5a40"}/>
            )
          }
        </div>
        <img src={thumb_opinion}/>
      </NavLink>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CoursePage/Components/ModuleNPSComponent.jsx